'use client'

import { useState, useEffect } from 'react'

import { IconChevronDown, IconChevronUp } from '@/components/Icon'
import Link from '@/components/Link'
import Typography from "@/components/Typography"

import { useClientMediaQuery } from "@/hooks/useClientMediaQuery"
import {SocialMediaIcon} from "@/components/SocialMedia";

type FooterGroupItemProps = {
    id?: string
    href: string
    icon?: string
    value: string
}

type FooterGroupProps = {
    id?: string
    header: string
    items: FooterGroupItemProps[]
}

const FooterGroup = (props: FooterGroupProps) => {

    const { id, header, items } = props

    const isMobile = useClientMediaQuery('(max-width: 768px)')
    const [hidden, toggle] = useState(isMobile)

    useEffect(() => {
        toggle(isMobile)
    }, [isMobile])

    return (
        <ul className="flex flex-col gap-4 md:mb-4">

            <li className='flex items-center justify-between py-2 md:p-0' onClick={() => (toggle(!hidden))}>
                <Typography variant="span">
                    {header}
                </Typography>
                <div className='md:hidden'>
                    {hidden ? <IconChevronDown /> : <IconChevronUp />}
                </div>
            </li>

            {id !== 'socials' && items.map((item, key) => (
                <li key={key} className={`py-2 md:p-0 ml-2 ${hidden && 'hidden'}`}>
                    <RenderLinkOrExtra {...item} />
                </li>
            ))}

            {id === 'socials' && (
                <li className={`py-2 md:p-0 ml-2 ${hidden && 'hidden'}`}>
                    <ul className='flex gap-4 md:mb-4'>
                        {items.map((item, key) => (
                            <li key={key}>
                                <SocialMediaIcon icon={item.icon as any} link={item.href} theme='light' />
                            </li>
                        ))}
                    </ul>
                </li>
            )}

        </ul>
    )
}

function RenderLinkOrExtra (item: FooterGroupItemProps) {
    if (item.id === 'showCookie') {
        return (
            <Typography id={item.id} variant='span' className='cursor-pointer'>
                {item.value}
            </Typography>
        )
    }

    return (
        <Link id={item.id} href={item.href} absolute>
            <Typography variant='span'>
                {item.value}
            </Typography>
        </Link>
    )
}



export { type FooterGroupProps }

export default FooterGroup